import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Sidebar from "../../../components/sidebar";
import { getCommunityTemplateDetail } from "../../../store/actions/ask/index";
import HeaderContent from "../../../components/headerContent";
import { FormattedMessage } from "react-intl";
import LoaderSimple from "../../../components/general/loader";
import DetailTemplatePage from "../../../components/ask/edit/dots/pages/detailTemplatePage";
import { useLocation, useNavigate } from "react-router-dom";

const DetailTemplateView = ({
  match,  
  accountantUuidSelected
}) => {

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const templateDetails = useSelector(state => state.ask.communityTemplateDetails.templateDetails);
  const auth = useSelector(state => state.auth);
  const main = useSelector(state => state.main);

  const [isLoading, setIsLoading] = useState(true);
  const isLoadingTemplateDetails = useSelector(state => state.ask.communityTemplateDetails.isGettingCommunityTemplateDetails);

  const templateId = match.params.id;

  useEffect(() => {
    dispatch(getCommunityTemplateDetail(templateId));
    setIsLoading(isLoadingTemplateDetails ? true : false);
  }, [auth, templateId, main.accountantUuidSelected]);

  const linkBack = {
    text: <FormattedMessage id="generic.back" />,
    pushUrl: "/ask-edit",
    winLocation: null
  };
  return (
    <div>
      <Sidebar
        activePage={location.pathname}
      />
      <div className="contentStructure transparent settings">
        {!isLoading && Object.keys(templateDetails).length > 0 ?
          (<>
            <HeaderContent	
              location={location}
              navigate={navigate}					  
						  linkBack={linkBack}
						  title={templateDetails.name}
						  subtitle={<FormattedMessage id="ask.pages.edit.communityTemplates.templateDetailSubtitle" />}
            />
            <DetailTemplatePage
						  templateDetails={templateDetails}
						  isLoading={isLoading}
						  templateId={templateId}
						  authorId={accountantUuidSelected}
            />
          </>
          ) : (<LoaderSimple />)
        }
      </div>
    </div>
  );
};

export default DetailTemplateView;